import { useEffect } from 'react';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import * as Icons from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Flex } from 'foundations-components/components/Flex';
import { HR } from 'foundations-components/transitional/components/HR';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import ServiceEvaluationSlideshowLink from './ServiceEvaluationSlideshowLink';
import { useLearnMoreConfig } from '../../../hooks/viewConfig';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnMoreLinks = {
  'service-slideshow': ServiceEvaluationSlideshowLink
};
const getIconComponent = iconName => {
  if (!iconName) {
    return Icons.WebsiteIcon;
  }
  const componentName = `${iconName.charAt(0).toUpperCase()}${iconName.slice(1)}Icon`;
  const IconComponent = Icons[componentName];
  if (!IconComponent) {
    return Icons.WebsiteIcon;
  }
  return IconComponent;
};
const LearnMoreCard = ({
  onboardingKey
}) => {
  const learnMoreConfig = useLearnMoreConfig(onboardingKey);
  const hasLearnMoreConfig = Boolean(learnMoreConfig);
  const {
    trackUserInteraction,
    trackSectionView
  } = useTracker();
  useEffect(() => {
    if (hasLearnMoreConfig) {
      trackSectionView('learn more card', onboardingKey);
    }
    if (learnMoreConfig && learnMoreConfig.ctas) {
      const ctas = learnMoreConfig.ctas;
      ctas.forEach(cta => {
        trackSectionView('viewed learn more cta', cta.ctaId);
      });
    }
  }, [hasLearnMoreConfig, trackSectionView, onboardingKey, learnMoreConfig]);
  if (!learnMoreConfig) {
    return null;
  }
  const {
    description,
    ctas = []
  } = learnMoreConfig;
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-card-locator": `${onboardingKey}-learn-more-card`,
    "data-test-id": "learn-more-card",
    children: [description && /*#__PURE__*/_jsx(CardSection, {
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h3",
        children: description
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: ctas.map(({
        ctaId,
        description: ctaDescription,
        external,
        href,
        icon,
        text
      }, index) => {
        const isLastItem = index === ctas.length - 1;
        const LearnMoreLink = LearnMoreLinks[ctaId] || Link;
        const IconComponent = getIconComponent(icon);
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            "data-test-id": "learn-more-card-item",
            gap: "300",
            marginBlock: "200",
            children: [/*#__PURE__*/_jsx(IconHolder, {
              color: "icon-core-subtle",
              icon: IconComponent,
              paddingInline: "0",
              size: "800"
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h5",
                children: /*#__PURE__*/_jsx(LearnMoreLink, {
                  external: external,
                  href: href,
                  onClick: () => trackUserInteraction('learn more cta click', ctaId),
                  children: text
                })
              }), ctaDescription && /*#__PURE__*/_jsx(Text, {
                marginBlockStart: "100",
                children: ctaDescription
              })]
            })]
          }), !isLastItem && /*#__PURE__*/_jsx(View, {
            marginBlock: "200",
            paddingInline: "1300",
            children: /*#__PURE__*/_jsx(HR, {
              color: "border-core-subtle",
              margin: "0"
            })
          })]
        }, index);
      })
    })]
  });
};
export default LearnMoreCard;